module.exports = __webpack_public_path__ + "assets/img/check.22aa31ec.svg";